"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var LastChargeDayInput = /** @class */ (function (_super) {
    __extends(LastChargeDayInput, _super);
    function LastChargeDayInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "last-charge-day-input";
        _this.value = _this.initValue || (new Date()).getFullYear();
        return _this;
    }
    LastChargeDayInput.prototype.onInitValueChanged = function (value) {
        this.value = value;
        this.$emit("input", value);
    };
    LastChargeDayInput.prototype.updateValue = function (value) {
        this.value = value;
        this.$emit("input", value);
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], LastChargeDayInput.prototype, "initValue", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], LastChargeDayInput.prototype, "disabled", void 0);
    __decorate([
        vue_property_decorator_1.Watch("initValue")
    ], LastChargeDayInput.prototype, "onInitValueChanged", null);
    LastChargeDayInput = __decorate([
        vue_class_component_1.default
    ], LastChargeDayInput);
    return LastChargeDayInput;
}(vue_property_decorator_1.Vue));
exports.default = LastChargeDayInput;
